import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID, RESPONSE_INIT } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { IServerCompanyResult, ServerCompanyService } from '@core/ssr/server-company.service';
import { ThemeConfig } from '@one/models/theme.model';
import { normalizeCompanySlug } from '@shared/utils/company-slug.utils';
import { catchError, map, Observable, of } from 'rxjs';
import { PublicThemeService } from './public-theme.service';

/** Só no SERVIDOR: escreve o tema no <html> do SSR. A empresa vem do ServerCompanyService (plano 5): uma chamada à API por SSR. */
export const publicThemeResolver: ResolveFn<ThemeConfig | null> = (route: ActivatedRouteSnapshot): Observable<ThemeConfig | null> => {
  if (isPlatformBrowser(inject(PLATFORM_ID))) return of(null);

  const publicTheme: PublicThemeService = inject(PublicThemeService);
  if (!publicTheme.enabled) return of(null); // o NavigationEnd aplica claro + roxo

  if (publicTheme.overrideFromQuery(route.queryParamMap)) {
    const init: ResponseInit | null = inject(RESPONSE_INIT, { optional: true });
    if (init?.headers instanceof Headers) init.headers.set('Cache-Control', 'private, no-store'); // nunca cachear prévia de QA na borda
    return of(null);
  }

  const slug: string | null = normalizeCompanySlug(route.paramMap.get('CompanySlug'));
  if (!slug) return of(null);

  return inject(ServerCompanyService)
    .load(slug)
    .pipe(
      map((result: IServerCompanyResult) => (result.company ? publicTheme.applyCompany(result.company) : null)),
      catchError(() => of(null))
    );
};
